import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from 'primereact/button';
import { JVInput } from '../../shared/JVInput';
import { JVDropdown } from '../../shared/JVDropdown';
import { JVDate } from '../../shared/JVDate';
import { Fetch } from '../../shared/Fetch';
import { JVDropdownInput } from '../../shared/JVDropdownInput';
import { ILogin } from '../../models/Login';
import { ITeamsDropdown } from '../../models/IDropdown';

interface IProps {
    filters: IAssignmentFilter,
    setFilters: (filters: IAssignmentFilter) => void,
    loading: boolean,
    // setLoading: (is: boolean) => void
}

const approvedStatus = [{ label: "Pending", value: false }, { label: "Approved", value: true },]
const verifiedStatus = [{ label: "Verified", value: 1 }, { label: "Reject", value: 0 }, { label: "Not Verified", value: 2 }]

export interface IAssignmentFilter {
    assigned_Name?: IAssignedName;
    assigned_Id?: number | null
    assignment_Name?: number | null;
    assignment_Start_Date?: Date | null;
    assignment_End_Date?: Date | null;
    approved_Status?: boolean | null;
    verified_Status?: number | null | boolean
    teamMemberId?: number | null
}
export const EmptyAssignmentFilter: IAssignmentFilter = {
    assigned_Id: null,
    assignment_Name: null,
    assignment_Start_Date: null,
    assignment_End_Date: null,
    approved_Status: null,
    verified_Status: null,
    teamMemberId: null
}

interface IAssignedName {
    user_Id?: number,
    user_Name?: string,
    user_Status?: boolean,
    role_Id?: number,
    branch_Id?: number
}

export interface ITeamList {
    teamMemberId: number,
    teamMemberName: string
}
const schema = yup.object().shape({

})
export const Filter = (props: IProps) => {
    const [assignment, setAssignment] = useState<any[]>([]);
    const [assignedName, setAssignedName] = useState<any[]>([]);
    const [teamList, setTeamList] = useState<Array<ITeamList>>()
    const [teamLead, setTeamLead] = useState<Array<ITeamsDropdown>>();
    
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IAssignmentFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const onSubmit = (data: IAssignmentFilter) => {
        // console.log(data);
        data.assigned_Id = data.assigned_Name?.user_Id;

        delete data.assigned_Name;

        if (data.verified_Status === 1) {
            data.verified_Status = true
        } else if (data.verified_Status === 0) {
            data.verified_Status = false
        } else {
            data.verified_Status = null
        }
        props.setFilters(data);
    }

    const loadAssignment = async () => {
        const response = await Fetch("DropDown/RoleWiseAssignment", "GET", null, null, null);
        if (response) {
            const data = await response.json();
            setAssignment(data);
        }
    }


    const loadBenchConsultant = async (filter: string | null) => {
        const response = await Fetch("Dropdown/usersRoleWise", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data = await response.json();
            setAssignedName(data);
        }
    }
    const completeMethodAssigned = (event: { query: string }) => {
        loadBenchConsultant(event.query);
    }

    const loadTeamList = async () => {
        const response = await Fetch("DropDown/teamList", "GET", null, null, null);
        if (response) {
            const data = await response.json();
            setTeamList(data);
        }
    }

     const loadTeam = async (type?: string) => {
            let queryParameter = null;
            // if (branch != 0 && branch != null) {
            //     queryParameter = `branch_ID=${branch}`;
            // } else if (company != 0 && company != null) {
            //     queryParameter = `company_ID=${company}`;
            // }
            if (type && type != "" && type != "-- SELECT --") {
                if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
                if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
            }
            const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
            if (response) {
                const data: Array<ITeamsDropdown> = await response.json();
                const emptyData = {
                    team_ID: 0,
                    team_Name: "-- SELECT --"
                };
                data.unshift(emptyData);
                setTeamLead(data);
            }
        }

    useEffect(() => {
        loadAssignment();
        loadTeamList();
        loadTeam();
    }, [])

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            {(_roles.includes(5) || _roles.includes(4)) && <JVDropdownInput column={4} completeMethod={completeMethodAssigned} label="Assigned Name" control={control} name="assigned_Name" options={assignedName} optionLabel="user_Name" placeholder="Search Assigned user  Name" />}
            <JVDropdown column={4} label='Assignment Name' name='assignment_Name' control={control} options={assignment} optionLabel='assignment_Name' optionValue='id' placeholder='-- Selelct Assignment --' />
            <JVDate column={4} label='Assignment Start Date' name='assignment_Start_Date' control={control} />
            <JVDate column={4} label='Assignment End Date' name='assignment_End_Date' control={control} />
            {_roles.includes(6) && <JVDropdown column={4} label='Team Member' name='teamMemberId' control={control} options={teamList} optionLabel='teamMemberName' optionValue='teamMemberId' placeholder='-- Select Team Member --' />}
            {(_roles.includes(5) || _roles.includes(4)) && <JVDropdown column={4} label='Approved Status' name='approved_Status' control={control} options={approvedStatus} optionLabel='label' optionValue='value' placeholder='-- Select Approved Status --' />}
            {(_roles.includes(5) || _roles.includes(4)) && <JVDropdown column={4} label='Verified Status' name='verified_Status' control={control} options={verifiedStatus} optionLabel='label' optionValue='value' placeholder='-- Select Verified Status --' />}
            {(_roles.includes(5) || _roles.includes(4)) &&  <JVDropdown column={6} label="Team" control={control} name="team" options={teamLead} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />}

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit" loading={props.loading}></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => reset(EmptyAssignmentFilter)} type="button"></Button>
            </div>
        </form>
    )
}
